<template>
  <el-form :model="fistFormData" :rules="fistFormRules" ref="fistFormRef" label-width="100px">
    <el-row :gutter="24">
      <el-col :span="6">
        <el-form-item label="公司代码" prop="companyCode">
          <el-input
            disabled
            v-model="fistFormData.companyCode"
            placeholder="请输入公司代码"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="公司名称" prop="companyName">
          <el-input
            disabled
            v-model="fistFormData.companyName"
            placeholder="请输入公司名称"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="创建时间" prop="createdAt">
          <el-date-picker
            disabled
            v-model="fistFormData.createdAt"
            placeholder="请选择创建时间"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="二级编码" prop="storageCode">
          <el-input
            disabled
            v-model="fistFormData.storageCode"
            placeholder="请输入二级编码"
          ></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="6">
        <el-form-item label="创建人" prop="storageCreatePersonName">
          <el-input
            v-model="fistFormData.storageCreatePersonName"
            disabled
            placeholder="请选择创建人"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="业务负责人" prop="personInChargeCode">
          <SearchTable
            searchType="personnel"
            isMultiple
            :disabled="isReadonly"
            @input="selectPersonInChargeHandler"
            :currentValue="fistFormData.personInCharge"
          ></SearchTable>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="联系人" prop="contactPerson">
          <el-input
            v-model="fistFormData.contactPerson"
            :disabled="isReadonly"
            placeholder="请输入联系人"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="审核状态" prop="currentStatus">
          <el-input v-model="currentStatusStr" disabled />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="联系电话" prop="contactTelephone">
          <el-input
            v-model="fistFormData.contactTelephone"
            :disabled="isReadonly"
            placeholder="请输入联系电话"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="二级名称" prop="storageName">
          <el-input
            v-model="fistFormData.storageName"
            placeholder="请输入二级名称"
            :disabled="isReadonly"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="是否专库" prop="isSpecial">
          <el-select
            v-model="fistFormData.isSpecial"
            placeholder="请选择是否专库"
            disabled
            style="width: 100%"
          >
            <el-option
              v-for="item of yesNoList"
              :value="item.value"
              :label="item.label"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="存放品种" prop="storageVariety">
          <el-select
            v-model="fistFormData.storageVariety"
            placeholder="请选择存放品种"
            style="width: 100%"
            :disabled="isReadonly"
            multiple
          >
            <el-option
              v-for="(item, index) of storageVariety"
              :value="item.value"
              :label="item.label"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="仓库类型" prop="storageType">
          <el-select
            v-model="fistFormData.storageTypeCode"
            placeholder="请选择仓库类型"
            disabled
            style="width: 100%"
          >
            <el-option
              v-for="(item, index) of storeType"
              :key="index"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <!-- <el-col :span="6">
        <el-form-item label="是否实体" prop="isReality">
          <el-select
            v-model="fistFormData.isReality"
            placeholder="请选择是否实体"
            style="width: 100%"
          >
            <el-option
              v-for="(item, index) of entityList"
              :key="index"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col> -->

      <el-col :span="6">
        <el-row :gutter="10">
          <el-col :span="16" style="padding-right: 0">
            <el-form-item label="省市" prop="provinceCode">
              <el-select
                filterable
                v-model="fistFormData.provinceCode"
                @change="changeProvinceHandler"
                placeholder="请选择省"
                clearable
                disabled
                @clear="clearProvinceHandler"
                style="width: 100%"
              >
                <el-option
                  v-for="item of provinceList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item class="isShowLabel" prop="cityCode">
              <el-select
                filterable
                v-model="fistFormData.cityCode"
                placeholder="请选择市"
                clearable
                disabled
                @clear="clearCityHandler"
                style="width: 100%"
              >
                <el-option
                  v-for="item of cityList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="12">
        <el-form-item label="详细地址" prop="storageAddress">
          <el-input
            v-model="fistFormData.storageAddress"
            disabled
            placeholder="请输入详细地址"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="所属组织" prop="storageCompanyObj">
          <BOrganizationTree
            v-model="fistFormData.storageCompanyObj"
            placeholder="请选择组织"
            :currentValue="fistFormData.storageCompanyName"
            :disabled="true"
            @setSearchModalHandler="changeOrganizationHandler"
          />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="所属一级" prop="belongToLevel1Name">
          <el-input
            disabled
            v-model="fistFormData.belongToLevel1Name"
            placeholder="请选择所属一级"
          />
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
  import { mapState } from 'vuex';
  import { fistFormRules } from './rules';
  import { yesNoList, entityList, storageVariety } from '@/constants';
  import SearchTable from '@/components/form-item/search-table';
  import BASE_API from '@/api/dataBase';
  import API from '@/api/masterData/cooperation.js';
  import storeMixin from './../../../storeMixin.js';
  export default {
    name: 'FormData',
    mixins: [storeMixin],
    props: {
      formData: {
        type: Object,
        default: () => {},
      },
      isReadonly: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        yesNoList,
        entityList,
        fistFormRules,
        storageVariety,
        fistFormData: {
          companyCode: '',
          companyName: '',
          personInCharge: '',
          createdAt: '',
          storageCode: '',
          personInChargeCode: '',
          contactPerson: '',
          contactTelephone: '',
          storageName: '',
          isSpecial: '',
          storageType: '',
          storageTypeCode: '',
          isReality: '',
          provinceCode: '',
          cityCode: '',
          storageAddress: '',
          storageVariety: '',
          storageCompanyCode: '',
          storageCompanyName: '',
          storageCompanyObj: null,
          belongToLevel1Name: '',
          belongToLevel1Id: '',
        },
        cityList: [],
        isDisabledCity: true,
      };
    },
    methods: {
      // 切换组织
      changeOrganizationHandler(obj) {
        this.fistFormData.storageCompanyCode = obj.id;
        this.fistFormData.storageCompanyName = obj.label;
      },
      // 切换省份
      changeProvinceHandler(value) {
        this.$axios.post(BASE_API.QUERY_CITY + '?parentAreaNo=' + value, {}).then((res) => {
          if (res.data.code === 0) {
            this.cityList = res.data.data;
            this.isDisabledCity = false;
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      clearProvinceHandler() {
        this.fistFormData = {
          ...this.fistFormData,
          provinceCode: '',
          cityCode: '',
        };
        this.isDisabledCity = true;
      },
      clearCityHandler() {
        this.fistFormData = {
          ...this.fistFormData,
          cityCode: '',
        };
      },
      // 选择人员下拉框
      selectPersonInChargeHandler(row) {
        this.fistFormData = {
          ...this.fistFormData,
          personInChargeCode: row[0]?.personNo,
          personInCharge: row[0].personName,
        };
      },
      // 校验一级名称是否重复
      async checkStoreNameBlurHandler(ev) {
        const storageNames = ev.target.value;
        this.checkStoreName(storageNames, '二');
      },
      validate(fn) {
        this.$refs.fistFormRef.validate((valid) => {
          if (valid) {
            delete this.fistFormData.createdAt;
            // delete this.fistFormData.storageCode;
            fn && fn(this.fistFormData);
          }
        });
      },
      // 获取创建人
      _initUserList() {
        this.$axios.post(API.GET_LIST_PERSON, { personInfo: '' }).then((res) => {
          if (res.data.code === 0) {
            this.requestByList = res.data.data.personInfo;
          }
        });
      },
    },
    mounted() {
      this._initUserList();
      if (this.$route.query?.status == 'create') {
        this.fistFormData = {
          ...this.fistFormData,
          storageCreatePersonNo: this.userInfo.userCode,
          storageCreatePersonName: this.userInfo.personName,
          companyName: this.userInfo.companyName,
          companyCode: this.userInfo.companyCode,
          createdAt: +new Date(),
        };
      }
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        provinceList(state) {
          return state.dict?.dictList?.find((it) => it.dictType == 'province')?.dictList;
        },
      }),
      storeType() {
        let list = this.$baseRequest.getDictListMapByType('storage_type');
        return list;
      },
    },
    watch: {
      formData: {
        handler: function (newVal) {
          console.log(newVal, '-获取到的数据--');
          if (newVal) {
            const {
              companyCode,
              companyName,
              personInCharge,
              storageCode,
              personInChargeCode,
              contactPerson,
              contactTelephone,
              storageName,
              isSpecial,
              storageType,
              storageTypeCode,
              isReality,
              provinceCode,
              cityCode,
              storageAddress,
              storageVariety,
              storageCompanyCode,
              storageCompanyName,
              belongToLevel1Name,
              belongToLevel1Id,
              storageCreatePersonNo,
              storageCreatePersonName,
              gmtCreate,
            } = newVal;
            this.fistFormData = {
              ...this.fistFormData,
              companyCode,
              companyName,
              personInCharge,
              storageCode,
              personInChargeCode,
              contactPerson,
              contactTelephone,
              storageName,
              isSpecial,
              storageType,
              storageTypeCode,
              isReality,
              provinceCode,
              cityCode,
              storageAddress,
              storageCompanyCode,
              storageCompanyName,
              belongToLevel1Name,
              belongToLevel1Id,
              storageCreatePersonNo,
              storageCreatePersonName,
              createdAt: gmtCreate,
              storageVariety: storageVariety?.split(','),
              storageCompanyObj: {
                storageCompanyCode,
                storageCompanyName,
              },
            };
            console.log(this.fistFormData.storageVariety, '111赋值1', this.fistFormData);
            this.changeProvinceHandler(provinceCode);
          }
        },
        immediate: true,
        deep: true,
      },
    },
    components: {
      SearchTable,
    },
  };
</script>

<style lang="scss" scoped>
  .isShowLabel {
    ::v-deep .el-form-item__content {
      margin-left: 0 !important;
    }
  }
</style>
